import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import {CampaignProfilePrlObj, ValidationResponseObj} from 'mx-core';
import {DataValidator} from '../../../shared/services/data-validator';

const PROFILES_API_URL = '/rest/profiles';


@Injectable({
    providedIn: 'root'
})
export class PrlProfilesDataService implements DataValidator<CampaignProfilePrlObj> {

    constructor(private http: HttpClient) {}

    validate(campaignProfileObj: CampaignProfilePrlObj, _url: string): Observable<ValidationResponseObj | null> {
        return this.http.post<null | ValidationResponseObj>(PROFILES_API_URL + '/validate', campaignProfileObj);
    }
}

